import { h, Component } from "preact";
import { css } from "emotion";
import Button from "../../components/Button";
import { Link } from "preact-router/match";
import ArrowRightIcon from "../../assets/images/icon-arrow-right.svg";
import { hexToRgba } from "../../utils/Format";

const styles = {
  rightCol: css`
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    margin-left: 24px;
    padding-top: 15px;
    @media (max-width: 600px) {
      padding-right: 50px;
      height: 118px;
    }
  `,
  buttonContainer: css`
    height: 36px;
    position: absolute;
    margin-top: auto;
    margin-bottom: auto;
    top: 0;
    bottom: 0;
    right: 16px;
  `,
  link: css`
    text-decoration: none !important;
    color: inherit !important;
  `,
  button: css`
    @media (max-width: 600px) {
      display: none;
    }
  `,
  buttonIcon: css`
    display: none;
    @media (max-width: 600px) {
      display: inherit;
    }
  `
};
/**
 * Display tiles view of featured events
 *
 * @param {*} props
 * @returns
 */
const EventDateListView = props => {
  const {
    event,
    theme = {},
    showPrice,
    eventListingLayout,
    noBottomBorder = false
  } = props;

  let bannerImage =
    event.featureImage && event.featureImage.url
      ? event.featureImage.url
      : null;
  bannerImage =
    event.socialImage && event.socialImage.url
      ? event.socialImage.url
      : bannerImage;
  const eventLink = `/${event.slug}`;
  const eventTitle =
    eventListingLayout === "eventTitle"
      ? event.name
      : event.location.titleLocation;
  const eventInfo =
    eventListingLayout === "eventTitle"
      ? event.location.titleLocation
      : event.name;
  const customStyles = {
    wrapper: css`
      width: 100%;
      height: ${showPrice ? "121px" : "100px"};
      display: flex;
      background: ${hexToRgba(
        theme.eventCardBackgroundColor,
        theme.cardAndBarOpacity
      )};
      border-bottom: ${noBottomBorder ? "none" : "1px solid #dedede"};
    `,
    dateCol: css`
      width: 79px;
      padding-top: 21px;
      // border-right: 8px dotted
      //   ${hexToRgba(
        theme.eventCardBackgroundColor,
        theme.cardAndBarOpacity
      )};
      border-right: 8px dotted #fafafa;
      vertical-align: middle;
      text-align: center;
      margin-bottom: 3px;
      margin-top: 3px;
    `,
    month: css`
      font-size: 16px;
      font-weight: 600;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#5a626c"
        : "#ffffff"};
      @media (max-width: 600px) {
        font-size: 14px;
      }
    `,
    day: css`
      font-size: 26px;
      font-weight: 600;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#323232"
        : "#ffffff"};
      @media (max-width: 600px) {
        font-size: 20px;
      }
    `,
    title: css`
      max-width: 470px;
      width: 100%;
      font-size: 18px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 4px;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#323232"
        : "#ffffff"};
      @media (max-width: 600px) {
        font-size: 16px;
      }
    `,
    contents: css`
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? "#5a626c"
        : "#ffffff"};
      max-width: 470px;
      width: 100%;
      @media (max-width: 600px) {
        font-size: 14px;
      }
    `
  };

  return (
    <div className={customStyles.wrapper}>
      <div className={customStyles.dateCol}>
        <div className={customStyles.month}>{event.dates[0].displayMonth}</div>
        <div className={customStyles.day}>{event.dates[0].displayDay}</div>
      </div>
      <div className={styles.rightCol}>
        <div className={customStyles.title}>{eventTitle}</div>
        <div className={customStyles.contents}>
          {event.dates[0].display.time}
        </div>
        {showPrice ? (
          <div className={customStyles.contents}>{event.ticketsPriceStr}</div>
        ) : null}
        <div className={customStyles.contents}>{eventInfo}</div>
        <div className={styles.buttonContainer}>
          <Link href={eventLink}>
            <div className={styles.button}>
              <Button tourTheme={theme} type="primary" ariaLabel="Get Tickets">
                {theme.ticketButtonText}
              </Button>
            </div>
            <img src={ArrowRightIcon} className={styles.buttonIcon} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventDateListView;



// WEBPACK FOOTER //
// ./routes/tours/EventDateListView.js